var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { enGB, et, ru } from 'date-fns/locale';
import { action, makeObservable, observable, computed } from 'mobx';
import { getSSOBackendURL } from '../util/environmentURL';
import { URLData } from '../index';
const DEFAULT_LANGUAGE = 'et';
const DEFAULT_APP = 'public';
const DEFAULT_BRAND = 'telia';
const DEFAULT_TIER = 'dev';
export default class EnvironmentStore {
    constructor(rootStore, props) {
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiBaseURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoBackendURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSPA", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "skipSsoModule", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setLang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lang) => {
                this.lang = lang;
                this.rootStore.externalCallbackStore.onLangChange(lang);
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        const { app, brand, tier, lang, apiBaseURL, isSPA, skipSsoModule } = props;
        this.setEnvironment(app, brand, tier, lang, apiBaseURL, getSSOBackendURL(tier, brand), isSPA, skipSsoModule);
    }
    get locale() {
        return this.lang === 'et' ? et : this.lang === 'ru' ? ru : enGB;
    }
    setEnvironment(app, brand, tier, lang, apiBaseURL, ssoBackendURL, isSPA, skipSsoModule) {
        this.app = app || DEFAULT_APP;
        this.brand = brand || DEFAULT_BRAND;
        this.tier = tier || DEFAULT_TIER;
        this.lang = lang || DEFAULT_LANGUAGE;
        this.apiBaseURL = apiBaseURL;
        this.ssoBackendURL = ssoBackendURL;
        this.isSPA = isSPA;
        this.skipSsoModule = skipSsoModule;
    }
    get URLData() {
        return new URLData({ app: this.app, brand: this.brand, tier: this.tier, lang: this.lang, apiBaseURL: this.apiBaseURL, ssoBackendURL: this.ssoBackendURL });
    }
}
__decorate([
    observable
], EnvironmentStore.prototype, "app", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "brand", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "tier", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "lang", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "apiBaseURL", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "ssoBackendURL", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "isSPA", void 0);
__decorate([
    observable
], EnvironmentStore.prototype, "skipSsoModule", void 0);
__decorate([
    computed
], EnvironmentStore.prototype, "locale", null);
__decorate([
    action
], EnvironmentStore.prototype, "setEnvironment", null);
__decorate([
    action
], EnvironmentStore.prototype, "setLang", void 0);
__decorate([
    computed
], EnvironmentStore.prototype, "URLData", null);
//# sourceMappingURL=EnvironmentStore.js.map